class FormManager {
    constructor() {
        // Constants and initial properties
        this.cookieGa = '_ga';
        this.ga6SKR50Z3WEValue = '_ga_6SKR50Z3WE';
        this.userAgent = navigator.userAgent;
        this.errorText = window.errorText || {}; // Global error messages
        this.successText = window.successText || {}; // Global success messages
        this.request = window.request || {}; // Global request URLs
        this.sbjs = window.sbjs || { get: { current: {} } }; // Global sbjs tracking
        this.lang = lang; // Replace with actual language detection logic

        this.cookieValueGa = '';
        this.cookieValuega6SKR50Z3WE = '';
        this.gclidValue = '';
        this.objectSbjs = {};

        this.init();
    }

    // Initialize the form manager
    init() {
        this.initializeCookies();
        this.initializeSbjs();
        this.bindEvents();
    }

    // Extract and store cookie values
    initializeCookies() {
        this.cookieValueGa = this.getCookie(this.cookieGa)?.substring(6) || '';
        this.cookieValuega6SKR50Z3WE = this.getCookie(this.ga6SKR50Z3WEValue) || '';
        this.gclidValue = this.getGclidFromSbjs();
    }

    // Initialize sbjs tracking data
    initializeSbjs() {
        this.objectSbjs = {
            utm_source: this.sbjs.get.current.src || '',
            utm_medium: this.sbjs.get.current.mdm || '',
            utm_campaign: this.sbjs.get.current.cmp || '',
            utm_content: this.sbjs.get.current.cnt || '',
            utm_term: this.sbjs.get.current.trm || '',
            client_id: this.cookieValueGa,
            session_id: this.cookieValuega6SKR50Z3WE,
            gclid: this.gclidValue,
            user_agent: this.userAgent,
        };

        window.objectSbjs = this.objectSbjs;
    }

    // Get cookie value by name
    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        return parts.length === 2 ? parts.pop().split(';').shift() : null;
    }

    // Extract gclid from sbjs cookie
    getGclidFromSbjs() {
        const sbjsCookieValue = this.getCookie('sbjs_current_add');
        if (!sbjsCookieValue) return '';
        const decodedString = decodeURIComponent(sbjsCookieValue);
        const match = /[?&]gclid=([^&#]*)/.exec(decodedString);
        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
    }

    // Bind all event listeners
    bindEvents() {
        $(document).ready(() => {
            this.handleModalClose();
            this.handleFormSubmit();
            this.handlePhoneMask();
            this.handlePasswordToggle();
            this.handleReviewPoint();
            this.handleReviewPointSelect();
            this.handleFormInput();
            this.handleEnterKey();
        });
    }

    // Handle form submission
    handleFormSubmit() {
        $(document).on('click', '.js_valid_form', (e) => {
            e.stopPropagation();
            e.preventDefault();
            const button = $(e.currentTarget);
            button.addClass('js__disabled');

            const successName = button.attr('data-success');
            let nameForm = button.attr('data-nameForm') || button.closest('.modal_wrap').attr('data-modal');
            const typePage = button.closest('.modal_wrap').attr('data-typepage') || '';

            const gtmObject = {
                location: button.attr('data-location') || '',
                formNameGtm: button.attr('data-formNameGtm') || '',
            };

            const dataBOC = {
                itemListNameGtm: button.attr('data-itemlistnamegtm') || '',
                indexGtm: button.attr('data-indexgtm') || '',
            };

            const dataObject = this.prepareFormData(button, nameForm);
            const errors = this.validateForm(button, nameForm);

            if (errors === 0) {
                this.submitForm(successName, dataObject, nameForm, typePage, gtmObject, dataBOC);
                $('.btn_buy').removeClass('btn_buy');
            } else {
                button.removeClass('js__disabled');
            }
        });
    }

    // Prepare form data for submission
    prepareFormData(button, nameForm) {
        const dataObject = { lang: this.lang };

        if (button.hasClass('js__name_form') || ['buyOneClick', 'makeBid'].includes(nameForm)) {
            if (['makeBid', 'buyOneClick'].includes(nameForm)) {
                if ($('.good_price_block .js_input_price').length > 0) {
                    $('.good_price_block .js_input_price .input_radio:checked').each(function () {
                        dataObject.price_type_id = $(this).val();
                    });
                } else {
                    dataObject.price_type_id = $('.good_price_block .new_prise').attr('data-price_type_id');
                }

                if ($('.garanty_good').length > 0 && $('#garanty_good_price').is(':checked')) {
                    dataObject.garanty = {
                        itemType: 'garanty_good',
                        guid: $('#garanty_good_price').attr('data-guid'),
                        garanty_price: $('.garanty_good .js__show').attr('data-price'),
                    };
                }
            } else {
                dataObject.price_type_id = '';
            }
        }

        if (nameForm === 'signService') {
            const serviceArticles = [dataObject.service_article].filter(Boolean);
            $('.js__service_article_chip:checked').each(function () {
                serviceArticles.push($(this).val());
            });
            dataObject.service_article = serviceArticles;
        }

        button.closest('.js_form_validate').find('input, textarea').each(function () {
            if ($(this).attr('type') === 'checkbox' || $(this).attr('type') === 'radio') {
                if ($(this).attr('name') === 'days') {
                    if ($(this).is(':checked')) {
                        dataObject[$(this).attr('name')] = $(this).val();
                    }
                } else {
                    dataObject[$(this).attr('name')] = $(this).is(':checked') ? $(this).val() : '';
                }
            } else {
                dataObject[$(this).attr('name')] = $(this).val();
            }
        });

        return dataObject;
    }

    // Validate form inputs
    validateForm(button, nameForm) {
        let errorInput = 0;
        let newPassOne = '';
        button.closest('.js_form_validate').find('.text_error').remove();
        button.closest('.js_form_validate').find('.input_error').removeClass('input_error');

        button.closest('.js_form_validate').find('input, textarea').each((_, element) => {
            const $input = $(element);
            if ($input.is(':required')) {
                const errorName = $input.attr('data-error');
                if ($input.val() === '') {
                    $input.addClass('input_error');
                    $input.after(`<p class="text_problem text_error">${this.errorText[errorName]}</p>`);
                    errorInput++;
                } else if (errorName === 'phone') {
                    const countNum = $input.val().replace(/\D/g, '').length;
                    if (countNum < 12) {
                        $input.addClass('input_error');
                        $input.after(`<p class="text_problem text_error">${this.errorText.phone_number}</p>`);
                        errorInput++;
                    }
                } else if (errorName === 'password_error') {
                    if ($input.attr('data-new') === 'main') {
                        newPassOne = $input.val();
                    } else if ($input.attr('data-new') === 'main_two' && newPassOne !== $input.val()) {
                        $input.addClass('input_error');
                        $input.after(`<p class="text_problem text_error">${this.errorText.password_now}</p>`);
                        errorInput++;
                    }
                }
            }
        });

        if (nameForm === 'reviews_site_send') {
            if (this.reviewsSiteSendValid()) {
                errorInput++;
            }
        }

        return errorInput;
    }

    // Submit form based on type
    submitForm(successName, dataObject, nameForm, typePage, gtmObject, dataBOC) {
        const handlers = {
            signVacancies: () => this.signVacancies(successName, dataObject),
            loginAccount: () => this.account(successName, dataObject, nameForm),
            registerAccount: () => this.registerAccount(successName, dataObject, nameForm),
            registerAccountB2B: () => this.registerAccountB2B(successName, dataObject, nameForm),
            registerAccountValid: () => this.registerAccountValid(successName, dataObject, nameForm),
            verification: () => this.appointVerifyPhone(successName, dataObject, nameForm),
            passwordForgot: () => this.passwordForgot(successName, dataObject, nameForm),
            contactEdit: () => contactEdit(successName, dataObject, nameForm),
            contactEditPassword: () => contactEditPassword(successName, dataObject, nameForm),
            orderRegistration: () => this.globalFormLogic(successName, dataObject, nameForm, typePage, gtmObject, dataBOC),
            reviews_site_send: () => this.reviewsSiteSend(successName, dataObject),
            submitFormExit: () => this.submitFormExit(successName, dataObject),
            сhip_tuning_forms_become: () => this.chipTuningSend(successName, dataObject, nameForm),
            сhip_tuning_forms_faqs: () => this.chipTuningSend(successName, dataObject, nameForm),
        };

        const handler = handlers[nameForm] || (() => this.globalFormLogic(successName, dataObject, nameForm, typePage, gtmObject, dataBOC));
        handler();
    }

    // Handle phone input mask
    handlePhoneMask() {
        $(document).on('input', '.js__mask_phone', function () {
            const phoneNumber = $(this).val().replace(/\D/g, '');
            if (phoneNumber.startsWith('3800')) {
                $(this).val('');
                return;
            }
            const prefix = phoneNumber.substring(3, 5);
            const allowedPrefixes = ['67', '96', '95', '98', '93', '97', '50', '77', '63', '99', '66', '68', '73', '91', '92', '94'];
            if (prefix.length === 2 && !allowedPrefixes.includes(prefix)) {
                $(this).val('');
            }
        });
    }

    // Handle password visibility toggle
    handlePasswordToggle() {
        $(document).on('click', '.js__view_password', function () {
            $(this).toggleClass('js_active');
            const inputPassword = $(this).closest('.password_view_block').find('input');
            inputPassword.attr('type', inputPassword.attr('type') === 'password' ? 'text' : 'password');
        });
    }

    // Handle input changes to enable buttons
    handleFormInput() {
        $(document).on('keyup', '.input_input', function () {
            $(this).closest('.js_form_validate').find('.js__disabled').removeClass('js__disabled');
        });
    }

    // Handle enter key for form submission
    handleEnterKey() {
        $(document).on('keydown', '.modal_wrap.js_open_modal, .js__keydown_service', function (e) {
            if (e.keyCode === 13) {
                $(this).find('.js_valid_form').trigger('click');
            }
        });
    }

    // Send chip tuning form
    chipTuningSend(successModal, value, nameForm) {
        $('.main_form_wrap').find('textarea, input').removeClass('input_error').val('');
        $('.main_form_wrap').find('.text_problem').remove();
        value.sabj = nameForm;

        $.post(this.request.сhipTuningSend, value, (data) => {
            if (data.status === 'ok') {
                this.sendSuccessForm(successModal, true);
            }
        });
    }

    // Handle account login
    account(successModal, value, nameForm) {
        const $modal = $(`.modal_wrap[data-modal=${nameForm}]`);
        $modal.find('input').removeClass('input_error');
        $modal.find('.text_problem').remove();

        $.post(this.request[nameForm], value, (data) => {
            if (data.status === 'ok') {
                if (data.error) {
                    if (data.error === 'error_phone_verify') {
                        $modal.find('.js_close_modal').trigger('click');
                        $('.modal_wrap[data-modal="registerAccountValid"] .js__open_window_now').trigger('click');
                        $('.modal_wrap[data-modal="registerAccountValid"] .js_user_id').val(data.user_id);
                    } else {
                        $modal.find(`input[data-errorReqiest=${data.error}]`)
                            .addClass('input_error')
                            .after(`<p class="text_problem text_error">${this.errorText[data.error]}</p>`);
                    }
                } else {
                    document.location.reload();
                    this.sendSuccessForm(successModal, true);
                }
            }
        });
    }

    // Handle password forgot
    passwordForgot(successModal, value, nameForm) {
        const $modal = $(`.modal_wrap[data-modal=${nameForm}]`);
        $modal.find('input').removeClass('input_error');
        $modal.find('.text_problem, .type_contact').remove();

        $.post(this.request.passwordForgot, value, (data) => {
            if (data.status === 'ok') {
                if (data.error) {
                    $modal.find(`input[data-errorReqiest=${data.error}]`)
                        .addClass('input_error')
                        .after(`<p class="text_problem text_error">${this.errorText[data.error]}</p>`);
                } else if (data.user_email && data.user_phone) {
                    $modal.find('.input_wrapper').hide().before(`
                        <div class="type_contact">
                            <div class="input_contact">
                                <input type="radio" id="email_user" name="type_contact" value="email">
                                <label for="email_user">${data.user_email}</label>
                            </div>
                            <div class="input_contact">
                                <input type="radio" id="phone_user" name="type_contact" value="phone">
                                <label for="phone_user">${data.user_phone}</label>
                            </div>
                        </div>`);
                    $modal.find('.type_contact_text').show();
                    $modal.find('.text_forgot').hide();
                } else {
                    this.sendSuccessForm(successModal, true);
                    $modal.find('.input_wrapper').show();
                    $modal.find('.type_contact').remove();
                    $modal.find('.type_contact_text').hide();
                    $modal.find('.text_forgot').show();
                }
            }
        });
    }

    // Handle B2B account registration
    registerAccountB2B(successModal, value, nameForm) {
        $.post(this.request[nameForm], value, (data) => {
            if (data.status === 'ok') {
                if (data.error) {
                    if (data.error === 'error_phone_verify') {
                        $('.modal_wrap[data-modal="registerAccountValid"] .js__open_window_now').trigger('click');
                        $('.modal_wrap[data-modal="registerAccountValid"] .js_user_id').val(data.user_id);
                    } else {
                        $('.js__register_b2b_form')
                            .find(`input[data-errorReqiest=${data.error}]`)
                            .addClass('input_error')
                            .after(`<p class="text_problem text_error">${this.errorText[data.error]}</p>`);
                    }
                } else {
                    this.sendSuccessForm(successModal, false);
                }
            }
        });
    }

    // Handle account registration
    registerAccount(successModal, value, nameForm) {
        const $modal = $(`.modal_wrap[data-modal=${nameForm}]`);
        this.loaderForm($modal, 'start', 'modal');
        $modal.find('input').removeClass('input_error');
        $modal.find('.text_problem').remove();

        $.post(this.request[nameForm], value, (data) => {
            if (data.status === 'ok') {
                this.loaderForm($modal, 'stop', 'modal');

                if (data.error) {
                    $modal.find(`input[data-errorReqiest=${data.error}]`)
                        .addClass('input_error')
                        .after(`<p class="text_problem text_error">${this.errorText[data.error]}</p>`);
                } else {
                    $modal.find('.js_close_modal').trigger('click');
                    $('.modal_wrap[data-modal="registerAccountValid"] .js__open_window_now').trigger('click');
                    $('.modal_wrap[data-modal="registerAccountValid"] .js_user_id').val(data.user_id);
                }
            }
        });
    }

    // Handle account validation
    registerAccountValid(successModal, value, nameForm) {
        const $modal = $(`.modal_wrap[data-modal=${nameForm}]`);
        $modal.find('input').removeClass('input_error');
        $modal.find('.text_problem').remove();
        this.loaderForm($modal, 'start', 'modal');

        $.post(this.request.verifyPhone, value, (data) => {
            if (data.status === 'ok') {
                this.loaderForm($modal, 'stop', 'modal');

                if (data.error) {
                    $modal.find(`input[data-errorReqiest=${data.error}]`)
                        .addClass('input_error')
                        .after(`<p class="text_problem text_error">${this.errorText[data.error]}</p>`);
                } else {
                    document.location.reload();
                    this.sendSuccessForm(successModal, true);
                    window.dataLayer.push({ ecommerce: null });
                    window.dataLayer.push({ event: 'sign_up' });
                }
            }
        });
    }

    // Handle phone verification appointment
    appointVerifyPhone(successModal, value, nameForm) {
        const $modal = $(`.modal_wrap[data-modal=${nameForm}]`);
        $modal.find('input').removeClass('input_error');
        $modal.find('.text_problem').remove();

        $.post(this.request.appointVerifyPhone, value, (data) => {
            if (data.status === 'ok') {
                if (data.error) {
                    $modal.find(`input[data-errorReqiest=${data.error}]`)
                        .addClass('input_error')
                        .after(`<p class="text_problem text_error">${this.errorText[data.error]}</p>`);
                } else {
                    this.sendSuccessForm(successModal, false, 'signService');
                    const gtmInfo = JSON.parse(value.gtm_info || '{}');
                    window.dataLayer.push(gtmInfo);
                }
            }
        });
    }

    // Handle form exit submission
    submitFormExit(successModal, value) {
        $.post(this.request.promptHelpOnFirstExit, value, (data) => {
            if (data.status === 'success') {
                this.sendSuccessForm(successModal, false);
                $('.modal_wrap .js__disabled').removeClass('js__disabled');
            }
        });
    }

    // Handle global form logic
    globalFormLogic(successModal, value, nameRequest, typePage, gtmObject, dataBOC = false) {
        let newName = '';
        let updatedNameRequest = nameRequest;

        switch (nameRequest) {
            case 'goodSignService':
                value.sbjs = this.objectSbjs;
                updatedNameRequest = 'signService';
                newName = 'goodSignService';
                break;
            case 'addToWaitlist':
                updatedNameRequest = 'addToWishlist';
                break;
            case 'buyOneClick':
            case 'makeBid':
            case 'signService':
            case 'callbackServiceAddress':
            case 'signServiceGood':
                value.sbjs = this.objectSbjs;
                if (nameRequest === 'callbackServiceAddress') {
                    updatedNameRequest = 'signService';
                    newName = 'callbackServiceAddress';
                } else if (nameRequest === 'signServiceGood') {
                    updatedNameRequest = 'signService';
                    newName = 'signServiceGood';
                }
                break;
        }

        if (updatedNameRequest === 'signService') {
            gtmObject.phone = value.phone;
            gtmObject.first_name = value.first_name;

            grecaptcha.ready(() => {
                grecaptcha.execute('6LfQtUUqAAAAAIsimWhluDlJpO7wokDDWU_8DFux', { action: 'submit' }).then((token) => {
                    value.google_token = token;
                    this.postForm(updatedNameRequest, value, successModal, typePage, gtmObject, newName, dataBOC);
                });
            });
        } else {
            this.postForm(updatedNameRequest, value, successModal, typePage, gtmObject, newName, dataBOC);
        }
    }

    // Post form data
    postForm(nameRequest, value, successModal, typePage, gtmObject, newName, dataBOC) {
        $.post(this.request[nameRequest], value, (data) => {
            if (data.status === 'ok') {
                if (data.data) {
                    this.gtmBocForm(nameRequest, data.data, dataBOC, data.id);
                } else {
                    this.gtmGlobalForm(nameRequest, typePage, gtmObject, newName);
                }

                if (nameRequest !== 'addToWishlist') {
                    this.sendSuccessForm(successModal, false, nameRequest);
                } else {
                    const $jsAnkerHere = $('.js__anker_here');
                    const id = $jsAnkerHere.attr('data-id');
                    $(`button[data-modal=addToWaitlist][data-id=${id}]`).find('.js__text_add').removeClass('hide');
                    $(`button[data-modal=addToWaitlist][data-id=${id}]`).find('.js__text_defolt').addClass('hide');
                    $(`button[data-modal=addToWaitlist][data-id=${id}]`).removeClass('modal_open');
                    $('.bg_modal_window').trigger('click');
                }

                $('.modal_wrap .js__disabled').removeClass('js__disabled');
            } else if (data.status === 'phone_verify') {
                $('.modal_wrap[data-modal=verification] .js__open_window_now').trigger('click');
                $('.modal_wrap[data-modal=verification] .js__appoint_id').val(data.appoint_id);
                this.gtmGlobalForm(nameRequest, typePage, gtmObject, newName, true);
            } else if (data.status === 'google_recapcha') {
                this.notVerifiedRcaptcha();
            } else if (data.status === 'exist') {
                this.existForm();
            } else if (data.status === 'exist_service') {
                this.existFormService();
            }
        });
    }

    // Handle successful form submission
    sendSuccessForm(nameForm, account = false, nameRequest = false) {
        if (nameForm !== 'successModalB2B') {
            const $successModal = $('.modal_wrap[data-modal=successModal]');
            $successModal.find('.modal_middle .account_forgot, .modal_middle .telegram_forgot').addClass('d_none');
            $successModal.find('.modal_middle .all_text').removeClass('d_none');

            if ($('.bg_modal_window').length === 0) {
                $('footer').after('<div class="bg_modal_window"></div>');
            }

            if (account) {
                $successModal.find('.modal_middle .all_text').addClass('d_none');
            }

            if ($successModal.find('.modal_middle .telegram_forgot').length === 0) {
                nameRequest = 'not_tg_text';
            }

            if (['signService', 'buyOneClick'].includes(nameRequest)) {
                $successModal.find('.modal_middle .telegram_forgot').removeClass('d_none');
            }

            $successModal.addClass('js_open_modal').find('.title_modal').empty().text(this.successText[nameForm]);
        }

        $('body').find('.text_error').remove();
        $('body').find('.input_error').removeClass('input_error');
        $('.modal_wrap').removeClass('js_open_modal');
        $('.modal_wrap .js__disabled').removeClass('js__disabled');

        if (nameForm !== 'successModalB2B') {
            const $successModal = $('.modal_wrap[data-modal=successModal]');
            $successModal.addClass('js_open_modal').find('.title_modal').empty().text(this.successText[nameForm]);

            if (!['signService', 'buyOneClick'].includes(nameRequest)) {
                setTimeout(() => {
                    $successModal.removeClass('js_open_modal');
                    $('.bg_modal_window').remove();
                }, 5000);
            }
        } else {
            $('.modal_wrap[data-modal=successModalB2B]').addClass('js_open_modal');
            if ($('.bg_modal_window').length === 0) {
                $('footer').after('<div class="bg_modal_window"></div>');
            }
            setTimeout(() => window.location.reload(), 5000);
        }
    }

    // Handle existing form error
    existForm() {
        if ($('.bg_modal_window').length === 0) {
            $('footer').after('<div class="bg_modal_window"></div>');
        }
        $('body').find('.text_error').remove();
        $('body').find('.input_error').removeClass('input_error');
        $('.modal_wrap').removeClass('js_open_modal');
        $('.modal_wrap .js__disabled').removeClass('js__disabled');
        $('.modal_wrap[data-modal=existForm]').addClass('js_open_modal');

        setTimeout(() => {
            $('.modal_wrap[data-modal=existForm]').removeClass('js_open_modal');
            $('.bg_modal_window').remove();
        }, 5000);
    }

    existFormService() {
        if ($('.bg_modal_window').length === 0) {
            $('footer').after('<div class="bg_modal_window"></div>');
        }
        $('body').find('.text_error').remove();
        $('body').find('.input_error').removeClass('input_error');
        $('.modal_wrap').removeClass('js_open_modal');
        $('.modal_wrap .js__disabled').removeClass('js__disabled');
        $('.modal_wrap[data-modal=existFormService]').addClass('js_open_modal');

        setTimeout(() => {
            $('.modal_wrap[data-modal=existFormService]').removeClass('js_open_modal');
            $('.bg_modal_window').remove();
        }, 5000);
    }

    // Handle reCAPTCHA verification failure
    notVerifiedRcaptcha() {
        if ($('.bg_modal_window').length === 0) {
            $('footer').after('<div class="bg_modal_window"></div>');
        }
        $('.banner_form_servise input').val('');
        $('body').find('.text_error').remove();
        $('body').find('.input_error').removeClass('input_error');
        $('.modal_wrap').removeClass('js_open_modal');
        $('.modal_wrap .js__disabled').removeClass('js__disabled');
        $('.modal_wrap[data-modal=notVerifiedRcaptcha]').addClass('js_open_modal');

        setTimeout(() => {
            $('.modal_wrap[data-modal=notVerifiedRcaptcha]').removeClass('js_open_modal');
            $('.bg_modal_window').remove();
        }, 5000);
    }

    // Handle GTM global form events
    gtmGlobalForm(nameRequest, typePage, gtmObject, newName = false, sendForInput = false) {
        const $infoGtm = newName
            ? $(`.modal_wrap[data-modal=${newName}] .js__gtm_data_hidden`)
            : $(`.modal_wrap[data-modal=${nameRequest}] .js__gtm_data_hidden`);
        let dataGtm;

        switch (nameRequest) {
            case 'addToWishlist':
                window.dataLayer.push({
                    event: 'add_to_waitlist',
                    item_id: $infoGtm.val(),
                });
                break;
            case 'signService':
                if (newName === 'goodSignService') {
                    dataGtm = {
                        event: 'form_submit',
                        form_name: 'sign_up_service',
                        location: 'service_catalog',
                        service_city: $infoGtm.attr('data-city'),
                        service_address: $infoGtm.attr('data-address'),
                        first_name: gtmObject?.first_name ?? undefined,
                        phone: gtmObject?.phone ?? undefined,
                        type: $infoGtm.attr('data-service'),
                    };
                } else if (newName === 'callbackServiceAddress') {
                    dataGtm = {
                        event: 'form_submit',
                        form_name: 'sign_up_service',
                        location: typePage,
                        service_city: $infoGtm.attr('data-city'),
                        service_address: $infoGtm.attr('data-address'),
                        first_name: gtmObject?.first_name ?? undefined,
                        phone: gtmObject?.phone ?? undefined,
                        type: $infoGtm.attr('data-service'),
                    };
                } else if (newName === 'signServiceGood') {
                    const $spanServiceGood = $('.js__good_service_hidden').first();
                    window.dataLayer.push({ ecommerce: null });
                    dataGtm = {
                        event: 'form_submit',
                        form_name: 'unit_repair',
                        location: 'main_form',
                        service_city: $spanServiceGood.attr('data-city'),
                        service_address: $spanServiceGood.attr('data-address'),
                        first_name: gtmObject?.first_name ?? undefined,
                        phone: gtmObject?.phone ?? undefined,
                        type: $spanServiceGood.attr('data-id'),
                    };
                } else {
                    const $spanSendForm = $('.js__gtm_data_hidden.js__send_form').first();
                    dataGtm = {
                        event: 'form_submit',
                        form_name: gtmObject.formNameGtm || 'sign_up_diagnosis',
                        location: gtmObject.location,
                        service_city: $spanSendForm.attr('data-city')?.trim(),
                        service_address: $spanSendForm.attr('data-address')?.trim(),
                        first_name: gtmObject?.first_name ?? undefined,
                        phone: gtmObject?.phone ?? undefined,
                        type: $spanSendForm.attr('data-service')?.trim(),
                    };
                }
                if (sendForInput) {
                    $('.js__gtm_info').val(JSON.stringify(dataGtm));
                } else {
                    window.dataLayer.push(dataGtm);
                }
                break;
        }
    }

    // Handle GTM buy-one-click form events
    gtmBocForm(nameRequest, data, dataBOC, orderId) {
        switch (nameRequest) {
            case 'makeBid':
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'form_submit',
                    form_name: 'price_offer',
                    location: 'main_form',
                    service_city: 'undefined',
                    service_address: 'undefined',
                    type: data.cat1 || null,
                });
                break;
            default:
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'purchase',
                    ecommerce: {
                        transaction_id: orderId,
                        affiliation: 'by_one_click',
                        value: data.total_price,
                        currency: 'UAH',
                        items: [{
                            item_name: data.name,
                            item_id: data.good_id,
                            price: Number(data.price),
                            item_brand: data.brand,
                            item_category: data.cat1 || null,
                            item_category2: data.cat2 || null,
                            item_category3: data.cat3 || null,
                            item_category4: data.cat4 || null,
                            item_variant: data.status,
                            item_list_name: dataBOC.itemListNameGtm,
                            index: Number(dataBOC.indexGtm),
                            quantity: data.quantity,
                        }],
                    },
                });
                $(`.js__update_block_gtm[data-idcart=${data.guid}] .js__delete_good_cart`).trigger('click');
                break;
        }
    }

    // Handle reviews site send
    reviewsSiteSend(successModal, value) {
        $('.reviews_site_send').find('textarea, input').removeClass('input_error').val('');
        $('.reviews_site_send').find('.text_problem').remove();

        $.post(this.request.reviewsSiteSend, value, (data) => {
            if (data.status === 'ok') {
                this.sendSuccessForm(successModal, true);
            }
        });
    }

    // Validate reviews site form
    reviewsSiteSendValid() {
        let error = 0;
        $('.valid_drop_point').each(function () {
            const open = $(this).closest('.js__open_filial').length;
            $(this).find('.required_input').each(function () {
                if ($(this).val() === '' && open !== 0) {
                    const $btn = $(this).closest('.valid_drop_point').find('.js__drop_review_point');
                    $btn.addClass('input_error').after(`<p class="text_problem text_error">${this.errorText[$btn.attr('data-error')]}</p>`);
                    error++;
                }
            });
        });
        return error > 0;
    }

    // Handle vacancies form submission
    signVacancies(successModal, value) {
        const files = [];
        $('.js__file_add_hidden').each(function () {
            files.push($(this).val());
        });
        value.files = files;

        $.post(this.request.signVacancies, value, (data) => {
            if (data.status === 'success') {
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'form_submit',
                    form_name: 'vacancies',
                    location: 'main_form',
                    service_city: value.cities_gtm || undefined,
                    service_address: undefined,
                    type: value.vacancies_gtm || undefined,
                });
                $('.js__form_vacancie input').val('');
                $('.js__form_vacancie .js__list_file').empty();
                this.sendSuccessForm(successModal, true);
            }
        });
    }

    // Handle review point dropdown
    handleReviewPoint() {
        $(document).on('click', '.js__drop_review_point', function () {
            const $this = $(this);
            $this.closest('.js_form_validate').find('.text_error').remove();
            $this.closest('.js_form_validate').find('.input_error').removeClass('input_error');

            if ($this.hasClass('open')) {
                $('.js__drop_review_point, .js__list_review_point').removeClass('open');
            } else {
                $('.js__drop_review_point, .js__list_review_point').removeClass('open');
                $this.addClass('open');
                $this.closest('.input_drop').find('.js__list_review_point').addClass('open');
            }
        });
    }

    // Handle review point selection
    handleReviewPointSelect() {
        $(document).on('click', '.js__btn_point', function () {
            const $this = $(this);
            const point = $this.closest('.input_drop').find('.js__drop_review_point').attr('data-point');
            const name = $this.text().trim();
            const id = $this.attr('data-id');

            if (point === 'type_send') {
                if (id == 2 || id == 3) {
                    $('.js__branches_type_review').addClass('js__open_filial').show();
                } else {
                    $('.js__branches_type_review').removeClass('js__open_filial').hide();
                }
                $this.closest('.input_drop').find('input[name="type_send"]').val(id);
                $this.closest('.input_drop').find('input[name="type_send_text"]').val(name);
            } else if (point === 'branches_type') {
                $this.closest('.input_drop').find('input[name="address_filial_id"]').val(id);
                $this.closest('.input_drop').find('input[name="address_filial_text"]').val(name);
            }

            $this.closest('.input_drop').find('.js__drop_review_point').empty().text(name);
            $('.js__drop_review_point, .js__list_review_point').removeClass('open');
        });
    }

    // Handle modal close button
    handleModalClose() {
        $(document).on('click', '.js_account_close', function () {
            const btn = $(this);
            const modalName = btn.closest('.modal_wrap').attr('data-modal');
            $(`.modal_wrap[data-modal=${modalName}]`).removeClass('js_open_modal');
        });
    }

    loaderForm(form, status, type) {
        if (type === 'modal') {
            this.handleModalLoader(form, status);
        } else if (type === 'block') {
            this.handleBlockLoader(form, status);
        }
    }

    // Handle modal loader
    handleModalLoader($form, status) {
        const $parent = $form.find('.modal_middle');
        if (status === 'start') {
            $parent.hide();
            $parent.after('<div class="loader_form js__loader_form"><img src="../images/MS_Preloader.gif" alt="preloader"></div>');
        } else {
            $parent.show();
            $form.find('.js__loader_form').remove();
            this.toggleButton('unDisabled', $form);
        }
    }

    // Handle block loader
    handleBlockLoader($form, status) {
        if (status === 'start') {
            $('footer').after('<div class="loader_form js__loader_form_block fixed"><img src="../images/MS_Preloader.gif" alt="preloader"></div>');
        } else {
            $('.js__loader_form_block').remove();
        }
    }

    // Toggle button disabled state
    toggleButton(state, $form) {
        const $button = $form.find('.js_valid_form');
        if (state === 'unDisabled') {
            $button.removeClass('js__disabled');
        } else {
            $button.addClass('js__disabled');
        }
    }
}

window.loaderForm = (form, status, type) => {
    new FormManager().loaderForm(form, status, type);
};

// Expose sendSuccessForm globally
window.sendSuccessForm = (nameForm, account, nameRequest) => {
    new FormManager().sendSuccessForm(nameForm, account, nameRequest);
};

// Instantiate the FormManager
$(document).ready(() => {
    new FormManager();
});